module.exports = __webpack_public_path__ + "files/SPIADI2022 - SF2H - Les bactériémies liées à un PICCline aujourd'hui.8b7994dea550e8b95f2b5fd62b6b5b79.pdf";